<template>
  <div>
    <div class="gps-geocoder">
      <div class="input-group input-group-sm">
        <div class="input-group-prepend">
          <button
            class="btn btn-secondary text-white bg-secondary"
            type="button"
            @click="handleGetCurrentPosition()"
          >
            <i class="fas fa-spinner fa-spin mr-1" v-if="GPS_IS_LOADING"></i
            ><i class="fas fa-crosshairs mr-1" v-else></i>GPS
          </button>
        </div>
        <b-form-input
          :value="GEOCODE_QUERY"
          @input="GEOCODE_SEARCH($event)"
          type="text"
          placeholder="Search for a location..."
          class="form-control"
          aria-label="Search for a location..."
        />
        <div class="input-group-append">
          <button
            v-if="GEOCODE_IS_LOADING"
            class="btn btn-secondary text-white bg-secondary"
            type="button"
          >
            <i class="fas fa-spinner fa-spin"></i>
          </button>
          <button
            v-else-if="GEOCODE_SUGGESTIONS.length !== 0"
            class="btn btn-secondary text-white bg-secondary"
            type="button"
            @click="GEOCODE_RESET"
          >
            <i class="fas fa-close"></i>
          </button>
          <button v-else class="btn btn-secondary text-white bg-secondary" type="button">
            <i class="fas fa-search"></i>
          </button>
        </div>
      </div>
      <div v-if="message" class="alert" :class="[`alert-${messageType}`]">
        {{ message }}
      </div>
      <ul v-if="GEOCODE_SUGGESTIONS.length !== 0" class="geocoder-results">
        <li
          v-for="result in GEOCODE_SUGGESTIONS"
          :key="result.magicKey"
          @click="handleSelectGeocode(result)"
          class="geocoder-result p-1 border-bottom"
        >
          {{ result.text }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "Geocoder",
  mounted() {
    this.$on("close-list", this.closeList);
  },
  computed: {
    ...mapState({
      GEOCODE_QUERY: (state) => state.map.GEOCODE_QUERY,
      GEOCODE_SUGGESTIONS: (state) => state.map.GEOCODE_SUGGESTIONS,
      GEOCODE_CANDIDATES: (state) => state.map.GEOCODE_CANDIDATES,
      GEOCODE_IS_LOADING: (state) => state.map.GEOCODE_IS_LOADING,

      GPS_POSITION: (state) => state.map.GPS_POSITION,
      GPS_IS_LOADING: (state) => state.map.GPS_IS_LOADING,

      message: (state) => state.map.message,
      messageType: (state) => state.map.messageType,
    }),
  },
  methods: {
    ...mapActions({
      GPS_GET_CURRENT_POSITION: "map/GPS_GET_CURRENT_POSITION",
      GEOCODE_SEARCH: "map/GEOCODE_SEARCH",
      GEOCODE_SELECT: "map/GEOCODE_SELECT",
      GEOCODE_RESET: "map/GEOCODE_RESET",
    }),
    async handleSelectGeocode(suggestion) {
      try {
        const topCandidate = await this.GEOCODE_SELECT(suggestion);
        if (topCandidate) {
          this.$emit("input", topCandidate);
          this.closeList();
        }
      } catch (error) {
        // vuex message contains the error
      }
    },
    async handleGetCurrentPosition() {
      try {
        const currentPosition = await this.GPS_GET_CURRENT_POSITION();
        if (currentPosition) {
          this.$emit("input", currentPosition);
          this.closeList();
        }
      } catch (error) {
        // vuex message contains the error
      }
    },
    closeList() {
      // Set the property that controls the popup/list to false
      this.GEOCODE_RESET();
    },
  },
  beforeDestroy() {
    this.GEOCODE_RESET();
    this.$off("close-list", this.closeList);
  },
};
</script>

<style scoped>
.geocoder {
  position: relative;
  width: 100%;
}
.geocoder-results {
  position: absolute;
  z-index: 10;
  background: white;
  border: 2px solid #ccc;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
}
.geocoder-result {
  cursor: pointer;
}
.geocoder-result:hover {
  background: #f0f0f0;
}
</style>
